// @flow
import * as React from 'react';
import { getAdItemTypeByVerticalName } from '../../../utils/schemaOrg';
import styles from './styles';

type Props = {
  ad: Object,
  verticalName: string,
  wasVisited: boolean,
  withRichData?: ?boolean,
  children: React.Node,
  onItemClicked: Function,
  dataTestId?: ?string,
  showBelly?: boolean,
};

function Snippet({
  ad,
  verticalName,
  wasVisited,
  onItemClicked,
  withRichData,
  children,
  dataTestId,
  showBelly,
}: Props): React.Node {
  const adId = ad.id;
  const redirectUrl = ad.redirectUrl;
  const dataTestValue = dataTestId && ad.premium ? `${dataTestId}-premium` : dataTestId;

  return (
    <a
      data-test={dataTestValue}
      href={redirectUrl}
      rel="nofollow"
      className={`snippet${wasVisited ? ' visited' : ''}${showBelly ? ' show-belly' : ''}`}
      id={adId}
      itemScope={withRichData}
      itemProp="offers"
      itemType={getAdItemTypeByVerticalName(verticalName)}
      onClick={onItemClicked}
    >
      {children}

      <style jsx>{styles}</style>
    </a>
  );
}

Snippet.defaultProps = {
  withRichData: null,
  dataTestId: null,
  showBelly: false,
};

export default Snippet;



// WEBPACK FOOTER //
// ./app/common/Snippet/shared/index.js